import React from 'react';
import ProjectBox from './ProjectBox';
import { projectData } from '../../Data/ProjectsData';

function ProjectsHighlights({ count = 3 }) {
  const highlights = projectData.slice(0, count);

  return (
    <div className="projects-content">
      <div className="project-list project-list-2">
        {highlights.map((project, index) => (
          <ProjectBox
            key={project.slug ?? index}
            slug={project.slug}
            heading={project.heading}
            description={project.description}
            name={project.name}
            namespan={project.namespan}
            image={project.image}
            alt={project.alt}
            type={'2'}
          />
        ))}
      </div>
    </div>
  );
}

export default ProjectsHighlights;
